export const SEARCH_RESULT_MESSAGES = {
    eligible: {
        title: 'Your address is eligible for connecting with nbn®.',
        detail: 'You currently have a {connection} connection at your address.',
        severity: 'success',
    },
    ineligible: {
        title: 'Unfortunately, you won’t be able to connect from your location.',
        severity: 'danger',
    },
    alternativeTechnology: {
        title: 'Great news! Your home is eligible for a <strong class="!tw-font-semibold">free</strong> fibre upgrade',
        detail: 'Upgrade to full fibre for a faster, more reliable internet connection.\n' +
            'You currently have a {connection} connection at your address.',
        severity: 'success',
    },
};